import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Після переходу між сторінками браузер лишає позицію прокрутки від
 * попередньої — людина клікає послугу і потрапляє в середину нової сторінки.
 * Якорі (/#contact) не чіпаємо: там прокруткою керує сама сторінка.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
